import type { RpmResponse, Status } from '@on3/api';
import { Check } from '@on3/ui-lib/components/Svg';
import { TeamAvatar } from 'components/Image/TeamAvatar';
import { getAbbreviatedRank } from 'components/Nil/helpers';
import { Text } from 'components/UI/Typography/Text';
import { format } from 'date-fns';

import styles from './CommitStatusNIL.module.scss';

interface ICommitStatusProps {
  commitStatus?: Status;
  predictions?: RpmResponse[] | null;
  statusClassName?: string;
}

export const CommitStatusNIL = ({
  predictions,
  commitStatus,
  statusClassName,
}: ICommitStatusProps) => {
  const {
    type,
    date,
    committedAsset,
    transferredAsset,
    committedOrganization,
    classRank,
  } = commitStatus || {};

  const hasStatus =
    type === 'Signed' || type === 'Enrolled' || type === 'Committed';
  const isSigned = type === 'Signed';
  const isEnrolled = type === 'Enrolled';
  const isCommitted = type === 'Committed';
  const commitDate = date && format(new Date(date), 'M/dd/yy');

  return (
    <div className={statusClassName}>
      {!!hasStatus && (
        <div className={styles.playerStatusContainer}>
          {committedAsset?.url && (
            <div className={styles.teamLogoContainer}>
              <img
                alt={`${committedOrganization?.fullName} Logo`}
                className={styles.teamLogo}
                height="50"
                src={committedAsset?.url}
                title={committedOrganization?.fullName ?? ''}
                width="50"
              />
            </div>
          )}
          <div className={styles.statusWrapper}>
            {hasStatus && (
              <TeamAvatar
                height={25}
                slug={committedOrganization?.name}
                src={committedOrganization?.assetUrl}
                width={25}
              />
            )}
            {isEnrolled && (
              <Text className={styles.position}>
                {getAbbreviatedRank(classRank ?? '')}
              </Text>
            )}
            {isSigned && !transferredAsset && (
              <div className={styles.commitWrapper}>
                <div className={styles.checkmarkContainer}>
                  <Check className={styles.checkmarkIcon} />
                </div>
                <Text className={styles.signed} variant="subtitle1">
                  Signed
                </Text>
              </div>
            )}
            {isCommitted && (
              <Text className={styles.dateWrapper}>
                <span>Commit</span>
                <span>{commitDate}</span>
              </Text>
            )}
          </div>
        </div>
      )}

      <div className={styles.predictionsContainer}>
        {!hasStatus &&
          predictions?.map((org) => {
            return (
              <div className={styles.prediction} key={org.key}>
                <TeamAvatar
                  className={styles.teamLogo}
                  height={30}
                  slug={org.organization?.slug}
                  src={org.organization?.assetUrl?.url}
                  width={30}
                />
                {org.percent && (
                  <Text variant="subtitle1">{org.percent.toFixed(1)}%</Text>
                )}
              </div>
            );
          })}
      </div>
    </div>
  );
};
